import { Station } from '@/models/station';
import { getCustomerName } from '@/misc/stationUtils';

/** Internal customers/projects excluded from report statistics only. */
const EXCLUDED_REPORT_CUSTOMER_NAMES = [
  'fahlke',
  'fcs',
  'fahlke control systems',
  'fahlke control systems kg',
];

/** Internal station names excluded from report statistics only. */
const EXCLUDED_REPORT_STATION_NAMES = [
  'fcs',
  'fahlke control systems',
];

function normalizeName(name: string): string {
  return name.trim().toLowerCase();
}

export function isExcludedReportCustomerName(name: string): boolean {
  return EXCLUDED_REPORT_CUSTOMER_NAMES.includes(normalizeName(name));
}

export function isExcludedReportStationName(name: string): boolean {
  return EXCLUDED_REPORT_STATION_NAMES.includes(normalizeName(name));
}

export function isExcludedReportStation(station: Station): boolean {
  if (isExcludedReportCustomerName(getCustomerName(station))) return true;
  return isExcludedReportStationName(station.name || '');
}

export function filterReportStations(stations: Station[]): Station[] {
  return stations.filter((station) => !isExcludedReportStation(station));
}

export function isExcludedReportMachine(machine: {
  station?: { name?: string; customer?: { name?: string } | null } | null;
}): boolean {
  const customerName = machine.station?.customer?.name;
  if (customerName && isExcludedReportCustomerName(customerName)) return true;

  const stationName = machine.station?.name;
  if (stationName && isExcludedReportStationName(stationName)) return true;

  return false;
}
